import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export class FormControlInvalidFieldsUtil {
  public static getInvalidControls(form: FormGroup | FormArray): string[] {
    const invalidControls: string[] = [];

    function traverse(control: AbstractControl, path: string) {
      if (control instanceof FormGroup) {
        Object.keys(control.controls).forEach((key) => {
          traverse(control.controls[key], path ? `${path}.${key}` : key);
        });
      } else if (control instanceof FormArray) {
        control.controls.forEach((ctrl, index) => {
          traverse(ctrl, `${path}[${index}]`);
        });
      } else if (control.invalid) {
        invalidControls.push(path);
      }
    }

    traverse(form, '');
    return invalidControls;
  }
}
